import { Component, HostBinding, Input, HostListener, ElementRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { DataService } from 'src/app/data.service';

@Component({
    selector: '[appSidebar]',
    host: {
        'class': 'c-sidebar c-sidebar-dark'
    },
    templateUrl: './sidebar.component.html'
})
// tslint:disable: curly variable-name
export class SidebarComponent {

    @HostBinding('class.c-sidebar-show') _alwaysShow = false;
    @HostBinding('class.c-sidebar-lg-show') _show = true;
    private _enableClickOutside = false;
    @Input()
    @HostBinding('class.c-sidebar-fixed') fixed = true;
    usuario: string[] = [];
    menuSubset = { exact: false };
    menusAbertos: { [chave: string]: boolean } = {};

    constructor(private eRef: ElementRef, private router: Router, public dataService: DataService) { }

  ngOnInit() {
    this.dataService.permissao$.subscribe(permissoes => {
      this.usuario = permissoes;
    });
    this.dataService.carregarPermissoes();
    this.abrirGrupoDaRota(this.router.url);
    this.router.events.subscribe(evento => {
      if (evento instanceof NavigationEnd) {
        this.abrirGrupoDaRota(evento.urlAfterRedirects);
      }
    });
  }

  alternarMenu(chave: string): void {
    const estava = this.menusAbertos[chave];
    this.menusAbertos = {};
    this.menusAbertos[chave] = !estava;
  }

  private abrirGrupoDaRota(url: string): void {
    const grupo = this.grupoDaRota(url || '');
    if (grupo) {
      this.menusAbertos = {};
      this.menusAbertos[grupo] = true;
    }
  }

  private grupoDaRota(url: string): string | null {
    if (url.includes('/relatorios')) return 'relatorios';
    if (url.includes('/contaPagar') || url.includes('/contaReceber') || url.includes('/contaCorrente')) return 'financeiro';
    if (url.includes('/client') || url.includes('/fornecedor') || url.includes('/plano') || url.includes('/segmento')) return 'cadastros';
    if (url.includes('/departamento') || url.includes('/cargo') || url.includes('/colaborador')) return 'rh';
    if (url.includes('/perfil') || url.includes('/usuario')) return 'acesso';
    if (url.includes('/ticket')) return 'tickets';
    return null;
  }


    toggle(): void {
        const smalScreen = window && window.innerWidth <= 992;
        if (smalScreen) {
            if (this._alwaysShow) {
                this._alwaysShow = false;
                this._show = false;
            } else {
                this._show = true;
                this._alwaysShow = true;
                this._enableClickOutside = false;
                setTimeout(() => this._enableClickOutside = true, 150);
            }
        } else {
            if (this._show || this._alwaysShow) {
                this._alwaysShow = false;
                this._show = false;
            } else {
                this._show = true;
            }
        }
    }

    @HostListener('document:click', ['$event'])
    clickout(event: any) {
        if (this._alwaysShow && this._enableClickOutside) {
            if (this.eRef.nativeElement.contains(event.target)) {
                // clicked inside
            } else {
                // clicked outside
                this._alwaysShow = false;
            }
        }
    }

}
